import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { userGroupsKeys } from './queryKeys';
import { useApplicationStore } from 'store/application';
import { updateUserGroupName } from 'api/userGroups.service';

export const useUserGroupUpdateNameQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate, data } = useMutation({
    mutationFn: (info: { userGroupId: string; newName: string }) => {
      setLoading();

      return updateUserGroupName(info.userGroupId, info.newName);
    },
    onSuccess: () => {
      toast.success('Group has been updated successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      removeLoading();
      queryClient.invalidateQueries({
        queryKey: userGroupsKeys.all,
      });
    },
  });

  return { isLoading: isPending, mutate, data };
};
